import ArrowLeftIcon from '@assets/icons/arrow-left.svg';
import React from 'react';
import { PageContainer } from '@/components/page-container';
import { SearchSubstitutionsContent } from '@/components/substitutions/search-substitutions-content';
import { StackScreenProps } from '@react-navigation/stack';
import { SUBSTITUTION_ROUTES } from '@/navigators/routes';
import { SubstitutionStackParams } from '@/navigators/types';

type Props = StackScreenProps<
  SubstitutionStackParams,
  SUBSTITUTION_ROUTES.SearchCatalog
>;

export const SearchCatalogScreen: React.FC<Props> = ({ navigation, route }) => {
  const {
    fulfillmentDate,
    itemWithSubstitute,
    orderUUID,
    variantPacksInOrder,
  } = route.params;

  return (
    <PageContainer
      navigationHeaderProps={{
        BackButtonIcon: ArrowLeftIcon,
        showBackButton: true,
        showShadow: false,
      }}
    >
      <SearchSubstitutionsContent
        availabilityFulfillmentDate={fulfillmentDate}
        onSelect={(substituteListOption, substitutionQuantity) => {
          navigation.navigate(SUBSTITUTION_ROUTES.SelectSubstitutionQuantity, {
            itemWithSubstitute,
            orderUUID,
            substituteListOption,
            substitutionQuantity,
          });
        }}
        variantPacksInOrder={variantPacksInOrder}
      />
    </PageContainer>
  );
};
